import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';
import { exercisesApi, RECENT_EXERCISES_TAG } from '@src/store/queries/exercises';

export const aiNutritionApi = createApi({
  reducerPath: 'aiNutritionApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['FoodAnalysis'],
  endpoints: (builder) => ({
    analyzeFoodImage: builder.mutation({
      query: ({ formData }) => ({
        url: '/ai-nutrition/analyze-food-image',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['FoodAnalysis'],
    }),
    markAsLogged: builder.mutation({
      query: (analysisId) => ({
        url: `/ai-nutrition/mark-logged/${analysisId}`,
        method: 'POST',
      }),
      invalidatesTags: ['FoodAnalysis'],
    }),
    getUserFoodAnalyses: builder.query({
      query: ({ userId, limit = 20 }) => `/ai-nutrition/user-analyses?userId=${userId}&limit=${limit}`,
      providesTags: ['FoodAnalysis'],
    }),
    analyzeExercise: builder.mutation({
      query: ({ description, userWeight }) => ({
        url: '/ai-nutrition/analyze-exercise',
        method: 'POST',
        body: { description, userWeight },
      }),
      // Newly cached / re-bumped recent entry — refresh the recents list in the
      // exercisesApi slice so the quick-relog UI updates without a manual refetch.
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(exercisesApi.util.invalidateTags([{ type: RECENT_EXERCISES_TAG, id: 'LIST' }]));
        } catch {
          // analysis failed — nothing to invalidate
        }
      },
    }),
  }),
});

export const {
  useAnalyzeFoodImageMutation,
  useMarkAsLoggedMutation,
  useGetUserFoodAnalysesQuery,
  useAnalyzeExerciseMutation,
} = aiNutritionApi;
